const SYSTEM_ACCOUNT_NAME_SPACE = 'SYSTEM_ACCOUNT@';

const createSystemAccountAction = (action) => {
  return `${SYSTEM_ACCOUNT_NAME_SPACE}${action}`;
};
export const SystemAccountAction = {
  setLoadingStatus: createSystemAccountAction('SET_LOADING_STATUS'),
  setAccountList: createSystemAccountAction('SET_ACCOUNT_LIST'),
  setRoleGroupList: createSystemAccountAction('SET_ROLE_GROUP_LIST'),
};
